import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    userSignedIn: Boolean,
  };

  connect() {
    this.initializeLanguage();
  }

  initializeLanguage() {
    const language = document.documentElement.dataset.language;
    this.applyLanguage(language);
  }

  change(event) {
    const language = event.currentTarget.dataset.language;
    const url = new URL(window.location.href);
    url.searchParams.set('locale', language);
    window.location.href = url.toString();
  }

  applyLanguage(language) {
    document.documentElement.dataset.language = language;
  }

  saveLanguagePreference(language) {
    if (!this.userSignedInValue) {
      localStorage.setItem("language", language);
      return;
    }

    fetch("/profile/update_language", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({ user: { language } }),
    }).then(() => {
      window.location.reload();
    });
  }
}
